var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M341.334 85.33H0v341.332h512V85.33z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.333h170.663V426.67H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M341.337 85.333H512V426.67H341.337z"
})));

export default SvgIt;